import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/saude/profissionais/listar/form_edit'
import Head from '../../../../../components/head'


function EditarProfissionaisaudeScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Profissional da Secretaria Municipal de Saúde" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarProfissionaisaudeScreen;